import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IrisCardFooterComponent } from './card-footer/card-footer.component';
import { IrisCardComponent } from './card.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    IrisCardComponent,
    IrisCardFooterComponent
  ],
  exports: [
    IrisCardComponent,
    IrisCardFooterComponent
  ]
})

export class IrisCardModule { }
